import React from 'react';

import { StyledLoader } from './Loader.styles';

import { LoaderProps } from './Loader.types';
import * as variants from './variants';

const Loader = ({
  variant = 'CircleDots',
  extraVariantComponents,
  componentClassname = 'loader',
  customClassnames = '',
  customStyle = '',
  additionalLoaderProps = {},
}: LoaderProps) => {
  const CurrentVariant = { ...variants, ...extraVariantComponents }[variant];

  return (
    <StyledLoader
      className={`${componentClassname} ${componentClassname}--is-variant-${variant} ${customClassnames}`}
      customStyle={customStyle}
    >
      <CurrentVariant {...additionalLoaderProps} />
    </StyledLoader>
  );
};
Loader.displayName = 'Loader';

export default Loader;
